import { responseError } from '@/utils/errors';
import { saveStates, states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { assignProps, removeItemByID } from '@/utils/resultsHelper';
import { closeDatasetNamespacesState, findDatasetNamespaces } from './state';
import actions from '../constants';

const updateNamespacesError = withDraft((draft, action) => {
  const item = findDatasetNamespaces(draft, action);
  if (item) {
    item.saveErrors = [responseError(action)];
    item.saveStatus = states.ERROR;
  }
});

const fetchNamespaces = withDraft((draft, { category, code }) => {
  const item = findDatasetNamespaces(draft, { category, code });

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.namespaces[category].results.push({
      code,
      namespaces: [],
      readErrors: [],
      readStatus: states.PENDING,
      ...saveStates,
    });
  }
});

const fetchNamespacesError = withDraft((draft, action) => {
  const item = findDatasetNamespaces(draft, action);
  if (item) {
    item.readStatus = states.ERROR;
    item.readErrors = [responseError(action)];
  }
});

const fetchNamespacesSuccess = withDraft((draft, { category, code, result }) => {
  const item = findDatasetNamespaces(draft, { category, code });
  const props = {
    namespaces: result,
    readErrors: [],
    readStatus: states.SUCCESS,
    ...saveStates,
  };

  if (item) {
    assignProps(item, props);
  } else {
    draft.namespaces[category].results.push({ code, ...props });
  }
});

const addNamespaceSuccess = withDraft((draft, { category, code, namespace }) => {
  const item = findDatasetNamespaces(draft, { category, code });
  if (item) {
    item.namespaces.push(namespace);
    item.saveStatus = states.SUCCESS;
    item.saveErrors = [];
  }
});

const removeNamespaceSuccess = withDraft((draft, { category, code, namespace }) => {
  const item = findDatasetNamespaces(draft, { category, code });
  if (item) {
    item.namespaces = removeItemByID(item.namespaces, namespace);
    item.saveStatus = states.SUCCESS;
    item.saveErrors = [];
  }
});

const updateNamespaces = withDraft((draft, { category, code }) => {
  const item = findDatasetNamespaces(draft, { category, code });
  if (item) {
    item.saveErrors = [];
    item.saveStatus = states.PENDING;
  }
});

export default {
  [actions.ADD_DATASET_NAMESPACE]: updateNamespaces,
  [actions.ADD_DATASET_NAMESPACE_SUCCESS]: addNamespaceSuccess,
  [actions.CLOSE_DATASET_NAMESPACES]: closeDatasetNamespacesState,
  [actions.FETCH_DATASET_NAMESPACES]: fetchNamespaces,
  [actions.FETCH_DATASET_NAMESPACES_ERROR]: fetchNamespacesError,
  [actions.FETCH_DATASET_NAMESPACES_SUCCESS]: fetchNamespacesSuccess,
  [actions.REMOVE_DATASET_NAMESPACE]: updateNamespaces,
  [actions.REMOVE_DATASET_NAMESPACE_SUCCESS]: removeNamespaceSuccess,
  [actions.UPDATE_DATASET_NAMESPACES_ERROR]: updateNamespacesError,
};
